// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import services from "./services";
import ticker from "./ticker";
import contactForm from "./contact-form";
import siteHeader from "./site-header";
import searchModal from "./searchModal";
import cursor from "./cursor";


cursor();
menuOpen();
infiniteScroll();
services();
ticker();
contactForm();
siteHeader();
searchModal();
